import { EMPTY_STATE } from "@common/constants";
import { isBoolean } from "@common/helpers/typeGuards";
import {
    FinancialAccount,
    FinancialAccountBase,
} from "@common/types/financialAccount";
import { FinancialConnectionWithAccounts } from "@common/types/financialConnection";
import { IntegrationConnection } from "@common/types/integrationConnection";

export function getAccountClassificationLabel(
    account: FinancialAccountBase,
): "Business" | "Personal" | typeof EMPTY_STATE {
    if (!isBoolean(account.isBusiness)) {
        return EMPTY_STATE;
    }

    return account.isBusiness ? "Business" : "Personal";
}

function isValidAccountEntity(account: FinancialAccount) {
    return !!account.entity;
}
export function isValidAccount(account: FinancialAccount) {
    return isValidAccountEntity(account);
}

export function isValidConnection(connection: FinancialConnectionWithAccounts) {
    return connection.accounts.every(
        (integrationAccount) =>
            integrationAccount.financialAccount &&
            isValidAccount(integrationAccount.financialAccount),
    );
}

export function isValidIntegrationConnection(
    connection: IntegrationConnection,
) {
    return (
        connection.integrationAccounts?.every(
            (integrationAccount) =>
                integrationAccount.financialAccount &&
                isValidAccount(integrationAccount.financialAccount),
        ) ?? false
    );
}
